import { IReportsSegmentRepository, TSegmentDownloadEvent, TSegmentUpdateEvent } from "domain/repositories/reports-segment-repository";
import { IHttpClient } from "../protocols/http";


export class ReportsSegmentDatasource implements IReportsSegmentRepository {
  constructor(
    private httpClient: IHttpClient,
    private baseUrl: string = process.env.REACT_APP_API_URL || ""
  ) {}

  async dashboardUpdateEvent(params: TSegmentUpdateEvent) : Promise<any> {
    return this.httpClient
      .request({
        method: "POST",
        baseUrl: this.baseUrl,
        url: "/v1/SegmentEvents/performance-dashboard-update",
        body: params,
      })
      .then(({ body }) => body.data);
  }

  async downloadEvent(params: TSegmentDownloadEvent) : Promise<any> {
    return this.httpClient
      .request({
        method: "POST",
        baseUrl: this.baseUrl,
        url: "/v1/SegmentEvents/performance-dashboard-download",
        body: params,
      })
      .then(({ body }) => body.data);
  }
}
